module.exports = __webpack_public_path__ + "assets/110eaedde6e8f2d929214f606d1617a3.png";